export const zoningEnvelopeDictionary = {
    AreaAllowedByFloorplate: '*Area Allowed by Floorplate',
    DensityNet: 'Dwelling Units per Acre',
    DensityUnits: 'Dwelling Units Allowed',
    FloorAreaRatio: 'FAR',
    FloorAreaRatioCapacity: '*Floor Area Ratio Capacity',
    LodgingCapacity: 'Maximum Lodging Rooms Allowed',
    LodgingCapacityCalculated: '*Lodging Capacity Calculated',
    LotAreaAcres: 'Lot Area in Acres',
    LotAreaFeet: 'Lot Area (GIS Simplified)',
    LotAreaPR: 'Lot Area (PR)',
    LotAreaFeetGAPI: 'Lot Area (GIS)',
    LotCoverage: 'Building Coverage',
    MaxBonusHeightAllowed: 'Bonus Allowed Height',
    MaxBuildingAreaAllowed: 'Maximum Built Area',
    MaxBuildingFootprint: 'Maximum Building Footprint',
    MaxCommercialAreaAllowed: 'Maximum Commercial Area',
    MaxCommercialEstablishedArea: 'Maximum Commercial Establishment Area',
    MaxCommercialHeightAllowed: 'Maximum Commercial Height',
    MaxLotCoverageArea: 'Custom Base Footprint Area',
    MaxOfficeAreaAllowed: 'Maximum Office Area',
    MaxOfficeCommercialAllowed: '*Max Office Commercial Allowed',
    MaxOfficeHeightAllowed: 'Maximum Office Height',
    MaxTowersNumber: 'Number of Towers',
    MaximumLodgingBuildableArea: 'Maximum Lodging Area',
    MaximumResidentialBuildableArea: 'Maximum Residential Area',
    MinOpenSpace: 'Minimum Open Space',
    MinOpenSpaceSquareFeet: '*Minimum Open Space (square feet)',
    Outbuilding: 'Outbuilding',
    PodiumArea: '*Podium Area',
    PrincipalMaxHeight: 'Principal Building Max. Height (Podium)',
    PrincipalMinHeight: 'Principal Building Min. Level (Podium)',
    PrincipalPenthouseHeight: '*Principal Penthouse Height',
    PrincipalTowerHeight: 'Principal Tower Allowed Height',
    SecondLayerDimension: 'Second Layer Dimension',
    TotalBuidingHeight: 'Total Building Height',
    TowerArea: '*Tower Area',
    TowerBonusMaxHeight: 'Tower Bonus Max. Height',
    TowerMaxArea: 'Custom Tower Footprint Area',
    TowerMaxAreaActual: '*Tower Max Area Actual',
    EffectivePFrontSetbackPrincipal: 'Effective Podium Front Setback Principal',
    EffectivePFrontSetbackSecondary: 'Effective Podium Front Setback Secondary',
    EffectivePRearSetback: 'Effective Podium Rear Setback',
    EffectivePSideSetback: 'Effective Podium Side Setback',
    EffectivePWaterSetback: 'Effective Podium Water Setback',
    EffectiveTFrontSetbackPrincipal: 'Effective Tower Front Setback Principal',
    EffectiveTFrontSetbackSecondary: 'Effective Tower Front Setback Secondary',
    EffectiveTRearSetback: 'Effective Tower Rear Setback',
    EffectiveTSideSetback: 'Effective Tower Side Setback',
    EffectiveTWaterSetback: 'Effective Tower Water Setback',
    EffectivePeFrontSetbackPrincipal: 'Effective Penthouse Front Setback Principal',
    EffectivePeFrontSetbackSecondary: 'Effective Penthouse Front Setback Secondary',
    EffectivePeRearSetback: 'Effective Penthouse Rear Setback',
    EffectivePeSideSetback: 'Effective Penthouse Side Setback',
    MaxIndustrialAreaAllowed: 'Maximum Industrial Area',
    MaxCivicAreaAllowed: 'Maximum Civic Area',
    MaxCivicSupportAreaAllowed: 'Maximum Civic Support Area',
    MaxEducationalAreaAllowed: 'Maximum Educational Area',
    IsComparedWithExistingEntity: 'Compared With Existing Entity',
    FieldsDifferenceFlags: 'Changed values',
    DensityUL: 'Residential Density UL',
    LodgingDensityUL: 'Lodging Density UL',

    // Virtual fields
    TotalBuildingHeightFeet: 'Maximum Building Height',
    EffectiveLotCoverage: 'Maximum Lot Coverage',
    EffectiveMinOpenSpace: 'Minimum Open Space',
    EffectiveDensityNet: 'Residential Density'
};

export const zoningEnvelopeNAFields = [
    'EffectivePFrontSetbackPrincipal',
    'EffectivePFrontSetbackSecondary',
    'EffectivePRearSetback',
    'EffectivePSideSetback',
    'EffectivePWaterSetback',
    'EffectiveTFrontSetbackPrincipal',
    'EffectiveTFrontSetbackSecondary',
    'EffectiveTRearSetback',
    'EffectiveTSideSetback',
    'EffectiveTWaterSetback',
    'EffectivePeFrontSetbackPrincipal',
    'EffectivePeFrontSetbackSecondary',
    'EffectivePeRearSetback',
    'EffectivePeSideSetback'
];
